import type { PropsWithClassName } from "@/components/podkit/lib/cn";
import type { FC } from "react";

// Simplified Anthropic logo rendered in the same style as other logos in this folder.
// Sized at 32x33 like AWSLogo/GCPLogo and accepts a className for sizing/tinting.
export const AnthropicLogo: FC<PropsWithClassName> = ({ className }) => {
    return (
        <svg
            className={className}
            width="32"
            height="33"
            viewBox="0 0 32 33"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-label="Anthropic Logo"
        >
            {/* Stylized "A" constructed from paths so we don't depend on fonts. */}
            <path
                d="M15.9999 4.99536C15.6124 4.99536 15.2509 5.2136 15.0926 5.5662L5.64693 26.5662C5.42354 27.0649 5.70226 27.642 6.20099 27.8654C6.69971 28.0888 7.27685 27.8101 7.50023 27.3114L10.2588 21.1954H21.741L24.4996 27.3114C24.723 27.8101 25.3001 28.0888 25.7989 27.8654C26.2976 27.642 26.5763 27.0649 26.3529 26.5662L16.9072 5.5662C16.749 5.2136 16.3874 4.99536 15.9999 4.99536Z"
                fill="currentColor"
            />
            {/* Crossbar */}
            <rect x="10" y="18.4954" width="12" height="2" rx="1" fill="#FFFFFF" />
        </svg>
    );
};
